import React from "react";
import FileTree from "./file-tree";
import FileBrowser from "./file-browser";
import BreadcrumbFile from "./bread-crumb-file";
import FileToolbar from "./file-toolbar";
import ShareEditor from "./share-editor";
import FileUpload from 'components/file-upload'
import { Search, Input, CopyClipboard } from "components/common";
import { getParents, updateFileWithHash, handleIcon, openFileInNewTab } from './filemanager-utils'

export default class FileManager extends React.Component {
    constructor(props) {
		super(props);
		this.state =  {
            selectedFiles: [],
            currentPath: [],
            searchTerm: "",
            currentFolder: null,
            canEdit: false,
            hasFolderSelected: false,
            filesToCopie: {
                files: [],
                isCutting: false
            },
            isContextMenuVisible: false,
            contextMenuPosition: { 
                top: 0, 
                left: 0
            },
            files: [],
            isFromEditor: props.isFromEditor || false
        };
	}

	componentDidMount() {
        this.fetchFiles('l1_LzAv');
	}

    onRefreshClicked = async () => {
        await this.handleOpenFile(this.state.currentFolder, true);
        this.setState(() => ({
            filesToCopie: {
                files: [],
                isCutting: false
            }
        }));
       
    }   

    fetchFiles = async (target) =>  {
        http.get('/filesmanager/getFiles.json', { target: target }, (response) => {
            const currentFolder = response.files.filter(item => item.hash == target)
           
            this.setState(() => ({
                files: currentFolder.length ? currentFolder : response.files,
                selectedFiles: [],
                currentFolder: currentFolder.length ? currentFolder : response.files[0],
                currentPath: currentFolder.length ? currentFolder : response.files,
            }));
        });
    };

    handleOpenFile = async (selectedFile, forceRefresh = false) => {

        if(!selectedFile.isFolder) {
            if (this.state.isFromEditor && this.props.onSelected) {
                this.props.onSelected(selectedFile);               
                return;
            }

            openFileInNewTab(selectedFile, false); 
            return;
        }

        if(!forceRefresh && selectedFile.hash == this.state.currentFolder.hash) {
            return;
        }
        const { files, filesToCopie, searchTerm } = this.state;

        http.get('/filesmanager/getChildren.json', { target: selectedFile.hash, isShared: selectedFile.isShared, searchTerm }, (response) => {
            const updatedFiles = updateFileWithHash(files, selectedFile.hash, response.current_folder.children);
            this.setState(() => ({
                files: updatedFiles,
                currentFolder: response.current_folder,
                selectedFiles: [],
                canEdit: filesToCopie.files.length ?? false,
                currentPath: [...getParents(response.current_folder.alias, files), selectedFile],
            }));
        });
    };

    handleSelectedRow = (selectedFiles, isMultipleSelection) => {
        const hasFolderSelected = selectedFiles.some(item => item.isFolder)
        if(!isMultipleSelection) {
            this.setState({ filesToCopie: {
                isCutting: false,
                files: []
            }});
        }
        
        this.setState({ selectedFiles, hasFolderSelected, canEdit: selectedFiles.length });
        if (this.state.isFromEditor && this.props.onSelected) {
            this.props.onSelected(selectedFiles);               
        }
    };

    onDuplicateClicked = async () => {
        const { selectedFiles } = this.state || {};
        const targets = selectedFiles.map(file => file.hash);
        http.post('/filesmanager/duplicateFolder.json', { targets: targets }, async (response) => {
           await this.onRefreshClicked();
        });
    }

    onDeleteClicked = async () => {
        const { selectedFiles } = this.state || {};
        const filesToBeDeleted = selectedFiles.map(file => file.name).join('<br>');
        const targets = selectedFiles.map(file => file.hash);
        mbox.confirmDelete(
			() => {
				http.post('/filesmanager/deleteFile.json', { targets: targets }, async (response) => {
					await this.onRefreshClicked();
					mbox.dismiss();
				})
			},
			`:<br> ${filesToBeDeleted}. <br> ${__('files_confirm_delete_obs')}`
		)
    }

    onRenameClicked = async () => {
        const { selectedFiles } = this.state || {};
        if(selectedFiles.length > 1) {
            return;
        }
        const newFileName = {value: selectedFiles[0].name};
        mbox.show(
            <div className="pcontent">
                <Input name="value" model={newFileName} className="form-control" />
            </div>,
            __('files_rename'),
            "edit",
            [
                "cancel",
                {
                    name: 'save',
                    onClick: () => {
                        http.post('/filesmanager/renameFile.json', { target: selectedFiles[0].hash, name: newFileName.value }, async () => {
                            await this.onRefreshClicked();
                            mbox.dismiss();
                        })
                    },
                },
            ],
            () => this.forceUpdate()
        );
    }

    handleBreadcrumbClick = (folder) => {
        if(folder.alias === this.state.currentFolder.alias){
            return
        }
        this.setState(() => ({
            selectedFiles: [],
            currentFolder: folder,
            currentPath: [...getParents(folder.alias, this.state.files), folder],
        }));
    };

    handleSearchChange = (value) => {
        this.setState({ searchTerm: value }, () => {
            this.onRefreshClicked();
        });
       
    };

    onNewFolderClicked = () => {
        const { currentFolder } = this.state || {};
        const newFolder = { value: '' };
        mbox.show(
            <div className="pcontent">
                <Input required placeholder={__('files_set_file_name')} name="value" model={newFolder} className="form-control" />
            </div>,
            "Nova pasta",
            "folder",
            [
                "cancel",
                {
                    name: 'save',
                    onClick: () => {
                        if(!newFolder.value){
                            mbox.error('Deve preencher o campo "nome da pasta"!', "Preencha o campo para continuar");
                            return 
                        }
                        http.post('/filesmanager/createFile.json', { target: currentFolder.hash, name: newFolder.value }, async (response) => {
                            await this.onRefreshClicked();
                            mbox.dismiss();
                        })
                    },
                },
            ],
            () => this.forceUpdate()
        );
    };

    onUploadClicked = async () => {
        const { currentFolder } = this.state || {};
        if(!currentFolder.hash) {
            return;
        }

        const onFileToUploadChange = () => {
           this.onRefreshClicked();
        }

        mbox.modal(
            <FileUpload handleFileToUpload={onFileToUploadChange} uploadURL={`/filesmanager/uploadFiles.json?target=${currentFolder.hash}`}/>,
            { buttons: []}
        )
    };

    onDownloadClicked = (file) => {
        const { selectedFiles } = this.state || {};
        // TODO: Para ja, apenas permite download de um ficheiro de cada vez e do tipo file, ou seja não folder. Mais tarde adicionar logica para fazer download de pasta, tem de converter para zip
        if(this.canDownload()) {
            openFileInNewTab(selectedFiles[0], true);
        }
    }

    canDownload = () => {
        const { selectedFiles } = this.state || {};
       return selectedFiles.length == 1 && !selectedFiles[0].isFolder;
    }

    onCutClicked = () => {
        const { selectedFiles } = this.state || {};
        this.setState({ filesToCopie: {
            files: selectedFiles,
            isCutting: true,
        }});
    }

    onCopyClicked = () => {
        const { selectedFiles } = this.state || {};
        this.setState({ filesToCopie: {
            files: selectedFiles,
            isCutting: false,
        }});
    }

    onPasteClicked = async () => {
        const { filesToCopie, currentFolder } = this.state || {};
        const targets = filesToCopie.files.map(file => file.hash);
        const copyTo = currentFolder

        http.post('/filesmanager/pasteFile.json', { targets: targets, dst: copyTo.hash, isCutting: filesToCopie.isCutting }, async (response) => {
            await this.onRefreshClicked();
            this.setState({ filesToCopie: {
                files: [],
                isCutting: false,
            }});
            mbox.dismiss();
            
        })
    }

    onInfoClicked = async () => {
        const { currentPath, selectedFiles } = this.state || {};
        const info = selectedFiles[0];
        const title = info.name;
       
		const filesizekb  = (info.size / 1024).toFixed(2);
		const filesizemb  = (filesizekb / 1024).toFixed(2);
		const size = filesizemb > 1 ? filesizemb +' Mb' : (filesizekb > 1 ? filesizekb +' Kb' : '') ;
        
        mbox.show(
            <div className="pcontent">
                <div className="row">
                    <div className="col col-md-1 text-right">
                        { handleIcon(info) }
                    </div>
                    <div className="col col-md-11">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>{__('files_type')}</td>
                                    <td title="File">{info.isFolder ? 'Folder' : 'File'}</td>
                                </tr>
                                {
                                    size ? 
                                    <tr>
                                        <td>{__('files_size')}</td>
                                        <td>
                                            <span title={size}>{size}</span>
                                        </td>
                                    </tr>  : null
                                }
                                <tr>
                                    <td>{__('files_path')}</td>
                                    <td>{`${currentPath.map(item => item.name).join('/')}/${title}`}</td>
                                </tr>
                                <tr>
                                    <td>{__('files_modified')}</td>
                                    <td>{info.updated_at}</td>
                                </tr>
                                <tr>
                                    <td>{__('files_module')}</td>
                                    <td className="text-capitalize">{info.module}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>,
            title,
        );
    }

    onOpen = (file) => {
        if(file.isFolder) {
            this.handleOpenFile(file, true);
            return
        }

        openFileInNewTab(file);
    }

    handleContextMenuOption = (option, file) => {
        switch (option) {
            case 'open':
                this.onOpen(file);
                break;
            case 'refresh':
                this.onRefreshClicked();
                break;
            case 'cut':
                this.onCutClicked()
                break;
            case 'copy':
                this.onCopyClicked()
                break;
            case 'paste':
                this.onPasteClicked(file)
                break;
            case 'newFolder':
                this.onNewFolderClicked()
                break;
            case 'delete':
                this.onDeleteClicked()
                break;
            case 'rename':
                this.onRenameClicked()
                break;
            case 'info':
                this.onInfoClicked()
                break;
            case 'share':
                this.onShareClicked(file);
                break;
            case 'download':
                openFileInNewTab(file, true);
                break;
            case 'copyUrl':
                CopyClipboard(file.url, __('files_copied_clipboard'));
                break;
            default:
                console.log('unkown context menu action', option, file);
                break;
        }
    }

    onShareClicked = (file = false) =>  {
        let selectedFile;
        if(file && !Array.isArray(file) && file.id) {
           selectedFile = [file];
        }
    
        const targets = selectedFile ? selectedFile : this.state.selectedFiles
        mbox.show(
            <ShareEditor targets={targets}/>,
            'Partilhar',
            null,
            null,
            () => this.onRefreshClicked()
        );   
    }

    render() {
        const { currentFolder, currentPath, canEdit, selectedFiles, filesToCopie, hasFolderSelected } = this.state || {};

        return (
            <div className="file-manager-container">
                <FileToolbar
                    isSharedFolder={currentFolder?.isShared}
                    newFolderOptions={{
                        onItemClicked: this.onNewFolderClicked,
                        disabled: false
                    }}
                    uploadOptions={{
                        onItemClicked: this.onUploadClicked,
                        disabled: false
                    }}
                    copyOptions={{
                        onItemClicked: this.onCopyClicked,
                        disabled: !canEdit

                    }}
                    duplicateOptions={{
                        onItemClicked: this.onDuplicateClicked,
                        disabled: !canEdit || hasFolderSelected
                    }}
                    cutOptions={{
                        onItemClicked: this.onCutClicked,
                        disabled: !canEdit
                    }}
                    pasteOptions={{
                        onItemClicked: this.onPasteClicked,
                        disabled: !canEdit || !filesToCopie.files.length
                    }}
                    deleteOptions={{
                        onItemClicked: this.onDeleteClicked,
                        disabled: !canEdit
                    }}
                    renameOptions={{
                        onItemClicked: this.onRenameClicked,
                        disabled: !canEdit || selectedFiles.length > 1
                    }}
                    refreshOptions={{
                        onItemClicked: this.onRefreshClicked
                    }}
                    menuActionItem={{
                        onItemClicked: this.onUploadClicked,
                        disabled: true
                    }}
                    downloadOptions={{
                        onItemClicked: this.onDownloadClicked,
                        disabled: !canEdit || !this.canDownload()
                    }}
                    shareOptions={{
                        onItemClicked: this.onShareClicked,
                        disabled: !canEdit
                    }}
                    infoOptions={{
                        onItemClicked: this.onInfoClicked,
                        disabled: !canEdit || selectedFiles.length > 1
                    }}
                    menuActionOptions={{
                        onItemClicked: this.onDownloadClicked,
                        disabled: true
                    }}
                />

                <div className="file-manager__body">
                    <FileTree 
                        files={this.state.files} 
                        onSelectedRow={this.handleOpenFile}
                    />

                    <div className="file-manager__body-files">
                        <div className="file-manager__body-files__toolbar">
                            <BreadcrumbFile path={currentPath} onClick={this.handleBreadcrumbClick} />
                            <div className="search">
                                <Search
                                    className="search"
                                    doSearch={this.handleSearchChange}
                                    placeholder="Procurar "
                                />
                            </div>
                        </div>
                            {currentFolder && (
                                <FileBrowser
                                    isCutting={filesToCopie.isCutting}
                                    canPaste={canEdit && filesToCopie.files.length}
                                    files={currentFolder.children ?? []}
                                    isSharedFolder={currentFolder?.isShared}
                                    onDoubleClickFileItem={this.handleOpenFile}
                                    onClickFileItem={this.handleSelectedRow}
                                    onContextMenuClicked={this.handleContextMenuOption}
                                />
                            )}
                    </div>
                </div>
            </div>
        );
    }
}
